// extracted by mini-css-extract-plugin
module.exports = {"fab":"BookingEnquiryWidget_fab__2xt1k","booking-enquiry-pulse":"BookingEnquiryWidget_booking-enquiry-pulse__3-uTS","phoneWrap":"BookingEnquiryWidget_phoneWrap__2yhBG"};